import React, { useState } from 'react';
import { api } from '../utils/api';

export const SettingsPage = ({ user, toast, onLogout }) => {
  const [botToken, setBotToken] = useState('');
  const [chatId,   setChatId]   = useState(user?.telegramChatId || '');
  const [saving,   setSaving]   = useState(false);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.updateTelegram({ telegramBotToken: botToken, telegramChatId: chatId });
      toast('Telegram settings saved!');
    } catch (err) {
      toast(err.message, 'error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={S.page}>
      {/* Profile */}
      <div style={S.card}>
        <h2 style={S.cardTitle}>👤 Account</h2>
        <div style={S.row}>
          <span style={S.label}>Name</span>
          <span style={S.value}>{user?.name}</span>
        </div>
        <div style={S.row}>
          <span style={S.label}>Email</span>
          <span style={S.value}>{user?.email}</span>
        </div>
        <div style={S.row}>
          <span style={S.label}>Plan</span>
          <span style={{ ...S.value, color: user?.plan === 'pro' ? '#ffd166' : '#00ff88' }}>
            {user?.plan?.toUpperCase()} · {user?.walletLimit} wallet{user?.walletLimit !== 1 ? 's' : ''}
          </span>
        </div>
        <button onClick={onLogout} style={S.btnDanger}>Logout</button>
      </div>

      {/* Telegram */}
      <div style={S.card}>
        <h2 style={S.cardTitle}>📱 Your Telegram Alerts</h2>
        <p style={S.hint}>
          Set up your own Telegram bot so alerts go directly to you.
          Create one at @BotFather and paste the token below.
        </p>
        <form onSubmit={handleSave} style={S.form}>
          <div style={S.field}>
            <label>Bot Token</label>
            <input value={botToken} onChange={e => setBotToken(e.target.value)}
              placeholder="123456789:ABCDEFGHijklmno..." />
          </div>
          <div style={S.field}>
            <label>Your Chat ID</label>
            <input value={chatId} onChange={e => setChatId(e.target.value)}
              placeholder="Get from @userinfobot" />
          </div>
          <button type="submit" style={S.btn} disabled={saving}>
            {saving ? '⏳ Saving…' : '✓ Save Telegram Settings'}
          </button>
        </form>
      </div>
    </div>
  );
};

const S = {
  page:     { display:'flex', flexDirection:'column', gap:24 },
  card:     { background:'#0d1117', border:'1px solid #1e2d3d', borderRadius:12, padding:'24px 28px' },
  cardTitle:{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:18, marginBottom:20 },
  row:      { display:'flex', justifyContent:'space-between', alignItems:'center',
              padding:'12px 0', borderBottom:'1px solid #1e2d3d' },
  label:    { fontSize:12, color:'#7a94b0', textTransform:'uppercase', letterSpacing:'0.06em' },
  value:    { fontSize:14, fontWeight:600 },
  hint:     { fontSize:13, color:'#7a94b0', marginBottom:20, lineHeight:1.6 },
  form:     { display:'flex', flexDirection:'column', gap:14 },
  field:    { display:'flex', flexDirection:'column', gap:6 },
  btn:      { background:'#00ff88', color:'#080b10', padding:'11px', fontWeight:700,
              fontSize:14, borderRadius:8, border:'none', cursor:'pointer', alignSelf:'flex-start' },
  btnDanger:{ background:'#ff4d6a15', color:'#ff4d6a', border:'1px solid #ff4d6a30',
              padding:'10px 20px', borderRadius:8, fontWeight:600, fontSize:13,
              marginTop:20, cursor:'pointer' },
};
